import { spCandidateSystemActivityCommentsLocs } from './components/candidate-comments/candidate-comments.locs';
import { spCandidateSystemActivityCommentsModalLocs } from './components/candidate-comments/comment-modal/comment-modal.locs';
import { spCandidateSystemActivityEmailHistoryLocs } from './components/candidate-email-history/candidate-email-history.locs';
import { spCandidateSystemActivityEmailHistoryPreviewModalLocs } from './components/candidate-email-history/email-preview-dialog/email-preview-dialog.locs';
import { spCandidateSystemActivityLoginsLocs } from './components/candidate-login-activity/candidate-login-activity.locs';
import { spCandidateSystemActivityMergeDetailListLocs } from './components/candidate-merges/candidate-merge-detail-list/candidate-merge-detail-list.locs';
import { spCandidateSystemActivityMergeDetailLocs } from './components/candidate-merges/candidate-merge-detail/candidate-merge-detail.locs';
import { spCandidateSystemActivityMergeDetailsExamsLocs } from './components/candidate-merges/candidate-merge-exams/candidate-merge-exams.locs';
import { spCandidateSystemActivityMergeDetailsIdsLocs } from './components/candidate-merges/candidate-merge-ids/candidate-merge-ids.locs';
import { spCandidateSystemActivityMergeDetailsRequirementsLocs } from './components/candidate-merges/candidate-merge-requirements/candidate-merge-requirements.locs';
import { spCandidateSystemActivityMergesLocs } from './components/candidate-merges/candidate-merges.locs';
import { spCandidateSystemActivityMergeUnmergeRequestDialogLocs } from './components/candidate-merges/unmerge-request-dialog/unmerge-request-dialog.locs';
import { spProfileAuditLocs } from './components/profile-audit/profile-audit.locs';

export const candidateSystemActivityModuleLocs = {
	...spCandidateSystemActivityEmailHistoryPreviewModalLocs,
	...spCandidateSystemActivityEmailHistoryLocs,
	...spProfileAuditLocs,
	...spCandidateSystemActivityLoginsLocs,
	...spCandidateSystemActivityMergeDetailListLocs,
	...spCandidateSystemActivityMergeDetailLocs,
	...spCandidateSystemActivityMergeUnmergeRequestDialogLocs,
	...spCandidateSystemActivityMergeDetailsExamsLocs,
	...spCandidateSystemActivityMergeDetailsIdsLocs,
	...spCandidateSystemActivityMergeDetailsRequirementsLocs,
	...spCandidateSystemActivityMergesLocs,
	...spCandidateSystemActivityCommentsLocs,
	...spCandidateSystemActivityCommentsModalLocs,
};
